import { Reveal } from "./Reveal";
import { useCopy } from "../i18n/copy";

export const ProcessSteps = ({ compact = false }) => {
  const { steps } = useCopy("process");
  return (
    <ol className={`grid gap-px bg-slate-200 border hairline ${compact ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-3"}`} data-testid="process-steps">
      {steps.map((step, i) => (
        <li key={step.n} className="bg-paper p-6 sm:p-8">
          <Reveal delay={i * 0.05}>
            <span className="font-mono text-sm text-terracotta tracking-widest" data-testid={`process-step-${step.n}`}>[{step.n}]</span>
            <h3 className="mt-3 text-lg font-semibold text-ink">{step.title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{step.text}</p>
          </Reveal>
        </li>
      ))}
    </ol>
  );
};
